export const APPOINTMENT_BOOKING_API_BASE_URL =
  'https://widget-data.service.elfsight.com/api';

// export const APPOINTMENT_BOOKING_API_BASE_URL_STAGE =
//   'https://feature-appointment-booking-widget-data.elfsight.dev/api';
